"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const machineTypes_1 = require("../utils/machineTypes");
const cart_1 = __importDefault(require("./cart"));
const empty_1 = __importDefault(require("./empty"));
const new_item_1 = __importDefault(require("./new-item"));
const Content = ({ data, status, onRouting, onClose, stateValue }) => {
    switch (stateValue) {
        case machineTypes_1.MachineTypes.OPEN_EMPTY:
            return (0, jsx_runtime_1.jsx)(empty_1.default, {});
        case machineTypes_1.MachineTypes.OPEN_NEW_ITEM:
            return (0, jsx_runtime_1.jsx)(new_item_1.default, { cart: data, onRouting: onRouting, onClose: onClose });
        case machineTypes_1.MachineTypes.OPEN_NEW_LOYALTY:
            return (0, jsx_runtime_1.jsx)(new_item_1.default, { cart: data, onRouting: onRouting, onClose: onClose, type: "loyalty" });
        case machineTypes_1.MachineTypes.OPEN_CART:
            return (0, jsx_runtime_1.jsx)(cart_1.default, { data: data, status: status, onRouting: onRouting });
        default:
            return null;
    }
};
exports.default = Content;
